import { CheckOutlined, CloseOutlined, InfoOutlined } from '@ant-design/icons';
import { Button, Flex, Modal, Typography } from 'antd';
import { useState } from 'react';
import { COLORS } from 'shared/const/theme';
import { RoundContainer } from 'shared/ui';
import ModalContext, { ModalOptions } from './ContextModal';


export const ModalProvider = ({ children }: { children: any }) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<ModalOptions>();

  const showResult = (options: ModalOptions) => {
    setOpen(true);
    setOptions({ ...options })
  }

  const onCancel = () => {
    setOpen(false);
  }

  const ResultIcon = () => {
    switch (options?.type) {
      case 'success':
        return (
          <RoundContainer size={48} color={COLORS.SUCCESS}>
            <CheckOutlined style={{ color: '#fff', fontSize: 24 }} />
          </RoundContainer>
        );
      case 'error':
        return (
          <RoundContainer size={48} color={COLORS.ERROR}>
            <CloseOutlined style={{ color: '#fff', fontSize: 24 }} />
          </RoundContainer>
        );
      case 'warning':
        return (
          <RoundContainer size={48} color={COLORS.WARNING}>
            <InfoOutlined style={{ color: '#fff', fontSize: 24 }} />
          </RoundContainer>
        );
      case 'info':
        return (
          <RoundContainer size={48} color={COLORS.INFO}>
            <InfoOutlined style={{ color: '#fff', fontSize: 24 }} />
          </RoundContainer>
        );
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    options?.actionButton?.onClick?.(event)
    onCancel();
  }

  return (
    <ModalContext.Provider
      value={{ showResult }}
    >
      {children}
      <Modal
        open={open}
        onCancel={onCancel}
        footer={null}
        centered
      >
        <Flex vertical gap={20} align='center'>
          <ResultIcon />
          <Typography.Title level={4}>{options?.title}</Typography.Title>
          <Typography.Text style={{ textAlign: 'center' }}>{options?.content}</Typography.Text>
          {options?.action && (
            <Button {...options.actionButton} onClick={handleClick}>{options.actionButton?.children}</Button>
          )}
        </Flex>
      </Modal>
    </ModalContext.Provider>
  )
}